import { getSMToken } from '_api/sm.js';
import { getCookie } from '_lib/utils';
var BASE_DOMAIN =
  location.host.indexOf('xiaoheihe.cn') >= 0 ? 'xiaoheihe.cn' : 'debugmode.cn';

// 暴露获取ID的函数
function injectGlobalFunc() {
  window.dealSmDeviceId = function (cb) {
    if (isCorrectToken(window._sm_device_id_, false)) {
      cb && cb(window._sm_device_id_);
      return;
    }
    var smTimeoutTime = 100;
    var smDeviceId = '';
    var smDeviceIdReady = false;
    var smTimer = setTimeout(function () {
      _callback();
    }, smTimeoutTime);

    SMSdk.ready(function () {
      clearTimeout(smTimer);
      _callback();
    });

    function _callback() {
      smDeviceId = SMSdk.getDeviceId ? SMSdk.getDeviceId() : smDeviceId;
      setDeviceIdAndTokenCookie(smDeviceId);

      if (!smDeviceIdReady) {
        smDeviceIdReady = true;
        //执行业务逻辑
        cb && cb(smDeviceId);
      }
    }
  };
}

// 获取数美脚本src
function getSMSrc() {
  var originHost = 'static.fengkongcloud.com';
  var isHttps = 'https:' === document.location.protocol;
  var protocol = isHttps ? 'https://' : 'http://';
  var fpJsPath = '/dist/web/v3.0.0/fp.min.js';
  var jsTimer = '?t=' + (new Date().getTime() / (6 * 3600 * 1000)).toFixed(0);
  var url = protocol + _smConf.staticHost + fpJsPath + jsTimer;
  var ua = navigator.userAgent.toLowerCase();
  var isWinXP = /windows\s(?:nt\s5.1)|(?:xp)/.test(ua);
  var isLowIE = /msie\s[678]\.0/.test(ua);
  if (isHttps && isWinXP && isLowIE) {
    url = protocol + originHost + fpJsPath + jsTimer;
  }
  return url;
}

// 注入脚本
function injectSMScript() {
  var url = getSMSrc();
  var sm = document.createElement('script');
  var s = document.getElementsByTagName('script')[0];
  sm.src = url;
  s.parentNode.insertBefore(sm, s);
}

function isCorrectToken(id, for_result = true) {
  if (!for_result) {
    return id && id.length === 89;
  } else {
    var token = getCookie('x_xhh_tokenid');
    if (id && id.length === 89) {
      return id;
    } else if (token) {
      return token;
    } else if (id && id.length > 89) {
      return getXHHToken(id);
    } else {
      return false;
    }
  }
}

function getXHHToken(data) {
  return getSMToken({
    box_data: data,
  }).then(({ data: { status, result, msg } }) => {
    if (status != 'ok') return msg;
    return result.heybox_token;
  });
}

async function setDeviceIdAndTokenCookie(value) {
  window._sm_device_id_ = await isCorrectToken(value);
  if (!window._sm_device_id_) return;
  var now = new Date();
  now.setTime(now.getTime() + 14 * 24 * 60 * 60 * 1000);
  document.cookie =
    'x_xhh_tokenid=' +
    escape(_sm_device_id_) +
    ';expires=' +
    now.toGMTString() +
    ';path=/;domain=' +
    BASE_DOMAIN;
}

function init() {
  window._smConf = {
    organization: '0yD85BjYvGFAvHaSQ1mc', //必填，组织标识，邮件中organization项
    appId: 'heybox_website', //必填，应用标识，默认传值default，其他应用标识提前联系数美协助定义
    publicKey:
      'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCXj9exmI4nQjmT52iwr+yf7hAQ06bfSZHTAHUfRBYiagCf/whhd8es0R79wBigpiHLd28TKA8b8mGR8OiiI1hV+qfynCWihvp3mdj8MiiH6SU3lhro2hkfYzImZB0RmWr2zE4Xt1+A6Oyp6bf+W7JSxYUXHw3nNv7Td4jw4jEFKQIDAQAB', //必填，私钥标识，邮件中publicKey项
    staticHost: 'static.portal101.cn',
    protocol: 'https',
  };
  window._smReadyFuncs = [];
  window.SMSdk = {
    onBoxDataReady: function (deviceId) {
      setDeviceIdAndTokenCookie(deviceId);
    },
    ready: function (fn) {
      fn && _smReadyFuncs.push(fn);
    },
  };
  injectSMScript();
  injectGlobalFunc();
}

try {
  init();
} catch (err) {
  console.log(err);
}
